import React, { useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import "./ParticularCourse.scss";
import { ImageLink } from "../../constants";
import SuggestedCourseCard from "../ExamPreparationCards/SuggestedCourseCard";
import DocPreview from "../DocPreview";
import { useNavigate } from "react-router-dom";
import CourseCardWithModal from "../../Pages/course/CourseCardWithModal";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const CoursePracPaper = ({ Link, course, id }) => {
  const navigator = useNavigate();
     const [modalOpen, setModalOpen] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const isPaid = false;
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const courseWithType = {
    ...course,
    tempCourse: {
      courseType: "Practice Papers",
      coursePrice: Link?.price,
      courseFilePath: Link?.filePath,
      courseTypeId: Link?._id,
    },
  };

   const toggleModal = () => setModalOpen(!modalOpen);
  return (
    <div className="course-study-note">
      {/* <p className="page-count">Preview 2 out of All Pages</p> */}
      <div className="row">
        <div className="col-lg-7">
          {Link?.filePath ? (
            <div className="pdf-preview-container">
              {isPaid ? (
                <div className="pdf-scrollable">
                  <Document
                    file={ImageLink(Link?.filePath)}
                    onLoadSuccess={onDocumentLoadSuccess}
                  >
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                  </Document>
                </div>
              ) : (
                <div className="pdf-preview">
                  <Document
                    file={ImageLink(Link?.filePath)}
                    onLoadSuccess={onDocumentLoadSuccess}
                  >
                    <div className="pdf-page-wrapper">
                      <Page pageNumber={1} />
                    </div>

                    <div className="pdf-page-wrapper">
                      <div className="blurred">
                        <Page pageNumber={2} />
                      </div>
                   
                      <div className="locked-pdf-div">
                        <div className="locked-pdf-div-content">
                          <div className="locked-pdf-div-content-flex">
                            <div className="locked-pdf-price">
                              Get Access - ${Link?.price}
                            </div>
                            <button
                              type="submit"
                              className="my-1 px-4 py-3 btn buy-locked"
                               onClick={toggleModal}>
                              View Full Document
                            </button>
                            <div>
                              <ul className="locked-pdf-div-content-list">
                                <li>Lifetime Access</li>
                                <li>No Hidden Charges</li>
                              </ul>
                            </div>
                          </div>

                          <div className="locked-pdf-div-content-bottom">
                            <p>🎓 Prepared by Former Alumni</p>
                            <p>✅ 100% Satisfaction Guarantee</p>
                          </div>
                        </div>

                      </div>
                    </div>
                  </Document>
                </div>
              )}
            </div>
          ) : (
            <DocPreview 
            course={courseWithType} 
            id={id} 
             toggleModal={toggleModal}
            />
          )}
        </div>
        <div className="col-lg-5 ps-0">
          <SuggestedCourseCard />
        </div>
      </div>

      <CourseCardWithModal 
      courseData={courseWithType} 
      redirectData={isPaid ? { ...course, price: Link?.price || 0 }: courseWithType}
      modalOpen={modalOpen}
      toggleModal={toggleModal}
      setModalOpen={setModalOpen}
      />
    </div>
  );
};

export default CoursePracPaper;
